export class MedicalFeeWithholdTaxAmount {
    public Id: number;
    public MedicalFeeWithholdTaxName: string;
    public Aliquot: number;
    public Amount: number;
    public WithholdTaxId: number;
    public AmountBase: number;
}
